export const ICON_SIZES = {
  X_SMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  X_LARGE: "xlarge",
  XX_LARGE: "xxlarge",
  XXX_LARGE: "xxxlarge",
  XXXX_LARGE: "xxxxlarge",
  MASTER: "master",
  NAV_SCREEN: "nav",
};

export const iconSizes = {
  [ICON_SIZES.X_SMALL]: "8px",
  [ICON_SIZES.SMALL]: "12px",
  [ICON_SIZES.MEDIUM]: "16px",
  [ICON_SIZES.LARGE]: "20px",
  [ICON_SIZES.X_LARGE]: "24px",
  [ICON_SIZES.XX_LARGE]: "32px",
  [ICON_SIZES.XXX_LARGE]: "48px",
  [ICON_SIZES.XXXX_LARGE]: "150px",
  [ICON_SIZES.NAV_SCREEN]: "70px",
  [ICON_SIZES.MASTER]: "84px",
};
